import React from 'react';
import VerificationQR from './VerificationQR.jsx';
import { API_BASE_URL } from '../../config.js';

const SignatureFooter = ({ footerConfig = {}, branding = {}, reportCardNumber = 'RC-2026-001', showQR = true }) => {
  const cfg = footerConfig || {};
  const BASE = API_BASE_URL || 'http://localhost:9980';

  const shouldShowQR = showQR !== false && cfg.showQR !== false;

  const displaySignature = branding.signatureUrl
    ? (branding.signatureUrl.startsWith('http') || branding.signatureUrl.startsWith('data:') ? branding.signatureUrl : `${BASE}${branding.signatureUrl.startsWith('/') ? '' : '/'}${branding.signatureUrl}`)
    : '';
  const displaySeal = branding.sealUrl
    ? (branding.sealUrl.startsWith('http') || branding.sealUrl.startsWith('data:') ? branding.sealUrl : `${BASE}${branding.sealUrl.startsWith('/') ? '' : '/'}${branding.sealUrl}`)
    : '';

  return (
    <div style={{ marginTop: 'auto', borderTop: '1px solid #e2e8f0', paddingTop: '14px', pageBreakInside: 'avoid' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        {cfg.showTeacherSignature !== false && (
          <div style={{ textAlign: 'center', width: '110px' }}>
            <div style={{ height: '32px', borderBottom: '1px solid #94a3b8' }}></div>
            <span style={{ fontSize: '8.5px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', marginTop: '4px', display: 'block' }}>
              Class Teacher
            </span>
          </div>
        )}

        {cfg.showParentSignature !== false && (
          <div style={{ textAlign: 'center', width: '110px' }}>
            <div style={{ height: '32px', borderBottom: '1px solid #94a3b8' }}></div>
            <span style={{ fontSize: '8.5px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', marginTop: '4px', display: 'block' }}>
              Parent Signature
            </span>
          </div>
        )}

        {cfg.showSchoolSeal !== false && (
          <div style={{ textAlign: 'center' }}>
            {displaySeal ? (
              <img src={displaySeal} alt="Seal" style={{ width: '55px', height: '55px', objectFit: 'contain' }} />
            ) : (
              <div style={{ width: '50px', height: '50px', borderRadius: '50%', border: '2px dashed #94a3b8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontSize: '7px', fontWeight: '700', color: '#94a3b8' }}>SEAL</span>
              </div>
            )}
          </div>
        )}

        {shouldShowQR && (
          <VerificationQR reportCardNumber={reportCardNumber} size="small" />
        )}

        {cfg.showPrincipalSignature !== false && (
          <div style={{ textAlign: 'center', width: '110px' }}>
            {displaySignature ? (
              <img src={displaySignature} alt="Signature" style={{ maxHeight: '32px', objectFit: 'contain' }} />
            ) : (
              <div style={{ height: '32px', borderBottom: '1px solid #94a3b8' }}></div>
            )}
            <span style={{ fontSize: '8.5px', fontWeight: '700', color: '#475569', textTransform: 'uppercase', marginTop: '4px', display: 'block' }}>
              Principal
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignatureFooter;
